/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Price_On_RequestInputs */

const cs_public_site_price_on_request = /** @type {(inputs: Public_Site_Price_On_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena na dotaz`)
};

const en_public_site_price_on_request = /** @type {(inputs: Public_Site_Price_On_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price on request`)
};

/**
* | output |
* | --- |
* | "Price on request" |
*
* @param {Public_Site_Price_On_RequestInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_price_on_request = /** @type {((inputs?: Public_Site_Price_On_RequestInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Price_On_RequestInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_price_on_request(inputs)
	return cs_public_site_price_on_request(inputs)
});